import {Component} from 'preact';
import Page from '../../page';

export default class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {data: this.props.data, progress: this.props.progress};
  }

  onNext() {
    this.setState(this.state.data);
  }

  render() {
    return (
      <Page {...this.state} onNext = {() => this.onNext()} />
    );
  }
};



// WEBPACK FOOTER //
// ./components/widget/view/abstract-layout.js